import './styles.scss'

const Realize = {
  i18n: window.Realize.i18n,
};

export function SearchBar({ searchValue, onSearch }) {
  const handleSearch = (e) => {
    onSearch(e.target.value);
  }

  return (
    <div className="search-bar-container">
      <div className='search-bar'>
        <i className='material-icons search-icon'>search</i>

        <input
          id='search-documents'
          type='text'
          placeholder={Realize.i18n.t('exportMultipleModal.search_by_field_name')}
          value={searchValue}
          onChange={handleSearch}
          tabIndex={0}
        />
      </div>
    </div>
  )
}